import angler from './angler';
import barnstormer from './barnstormer';
import chef from './chef';
import chronomancer from './chronomancer';
import disco from './disco';
import glacier from './glacier';
import glitch from './glitch';
import jester from './jester';
import knight from './knight';
import luchador from './luchador';
import magician from './magician';
import ooze from './ooze';
import origami from './origami';
import pirate from './pirate';
import plague from './plague';
import sheriff from './sheriff';

/** The mythic guns after the first four (ADR-0160 amended), a file a set. */
export const MYTHIC_GUNS = [
  glacier,
  angler,
  jester,
  plague,
  chronomancer,
  glitch,
  disco,
  origami,
  ooze,
  barnstormer,
  pirate,
  magician,
  chef,
  knight,
  sheriff,
  luchador,
];
